














import Vue from "vue";
import * as routes from "@/router/routes";

import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import SecurityMainTable from "./SecurityMainTable.vue";
import {
    FetchInstallationsSecurityConfigurationCommand,
    FetchInstallationsSecurityConfigurationReqData,
    GetFetchInstallationsSecurityConfigurationReqData,
} from "@/model/communication/security/FetchInstallationsSecurityConfigurationCommand";
import { FetchInstallationsSecurityConfigurationResData } from "@/model/communication/security/FetchInstallationsSecurityConfigurationResData";

import { dataTableItemsPerPage } from "@/utility/Constants";

import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

export default Vue.extend({
    components: {
        StandardPage,
        SecurityMainTable,
    },
    data() {
        return {
            SecurityMainTable,
            routes,
            loading: false,
            totalsLoading: false,
            reqData: null,
            installations: [],
            paginatedTotalItems: null,
            dataTableItemsPerPage,
            metricsTotals: null,
            lastSort: "",
            lastDesc: null,
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.reqData = request;
                this.loading = true;
                var response: FetchInstallationsSecurityConfigurationResData = await new FetchInstallationsSecurityConfigurationCommand(
                    GetFetchInstallationsSecurityConfigurationReqData(request)
                ).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installationsList;
                    this.paginatedTotalItems = response.totalInstallationsCount;
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationsSecurityConfiguration request ", e);
            }
            this.loading = false;
        },

        async sendRequestAndBackToTheFirstPage(request) {
            this.$refs.standardPage.backToTheFirst();
            this.sendRequest(request);
        },
    },
    mounted() {
        if (this.$route.query.reqData != null && this.$route.query.reqData != undefined) {
            this.reqData = JSON.parse(atob(this.$route.query.reqData));
        } else {
            this.reqData = new FetchInstallationsSecurityConfigurationReqData();
            this.reqData.queryLimit = this.dataTableItemsPerPage[0];
        }
    },
});
